<template>
    <div v-if="user" class="md-layout md-gutter">
      <div class="md-layout-item md-size-100 md-small-size-100 mt-4">
        <div class="md-layout-item md-size-100">
          <edit-profile-card :user="user" :apiValidationErrors="apiValidationErrors"/>
        </div>
        <div class="md-layout-item md-size-100">
          <edit-password-card :user="user" :apiValidationErrors="apiValidationErrors"/>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import EditProfileCard from "@/pages/Dashboard/Users/UserProfile/EditProfileCard.vue";
    import EditPasswordCard from "@/pages/Dashboard/Users/UserProfile/EditPasswordCard.vue";
    import formMixin from "@/mixins/form-mixin";
  
    export default {
      name: "edit-user",
  
      components: {
        "edit-profile-card": EditProfileCard,
        "edit-password-card": EditPasswordCard
      },
  
      data: () => ({
        user: {name:"",phone:"",email:"",password:"",password_confirmation:""}
      }),

      mixins: [formMixin],

      created() {
        this.getProfile();
      },
      methods: {
      async getProfile() {
        
        await this.$store.dispatch("users/get",this.$route.params.id)
        this.user = await this.$store.getters["users/user"]
      }
    }
    }
  </script>